export default __webpack_public_path__ + "static/media/care.ace4d77e.png";